module.exports = __webpack_public_path__ + "static/thatsislandology-c31977caf083b4184648014f044a9da0.svg";